import { render, staticRenderFns } from "./LogsUsuario.vue?vue&type=template&id=c54fc202"
import script from "./LogsUsuario.vue?vue&type=script&lang=js"
export * from "./LogsUsuario.vue?vue&type=script&lang=js"
import style0 from "./LogsUsuario.vue?vue&type=style&index=0&id=c54fc202&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports